import apiClient from "./api-client";
import StorageHelper from "../utils/storage-helper";

const getHeaders = () => ({
  headers: {
    Authorization: 'Bearer ' + StorageHelper.get('token'),
    'Content-Type': 'application/json'
  }
});

const BASE_URL = process.env.REACT_APP_DOVESAPI + 'policy';

export const approveApplication = async (applicationId) => {
  return apiClient.post(`${BASE_URL}/${applicationId}/approve`, null, getHeaders());
};

export const rejectApplication = async (applicationId) => {
  return apiClient.post(`${BASE_URL}/${applicationId}/reject`, null, getHeaders());
};
